import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-247eebfd")

_pushScopeId("data-v-247eebfd")
const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { class: "flex flex-col justify-center h-full" }
const _hoisted_3 = { class: "flex items-center justify-center h-full" }
const _hoisted_4 = {
  key: 1,
  class: "error"
}
const _hoisted_5 = { class: "relative" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ['bal-text-input', _ctx.wrapperClasses]
  }, [
    (!!_ctx.label)
      ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: ['input-group', _ctx.inputGroupClasses]
    }, [
      (_ctx.$slots.prepend)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ['prepend', _ctx.prependClasses]
          }, [
            _renderSlot(_ctx.$slots, "prepend", {}, undefined, true)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: ['input-container', _ctx.inputContainerClasses]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("input", _mergeProps({
            class: [_ctx.inputClasses],
            type: _ctx.type,
            name: _ctx.name,
            value: _ctx.modelValue
          }, _ctx.$attrs, {
            disabled: _ctx.disabled,
            onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
            onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args)))
          }), null, 16, ["type", "name", "value", "disabled"]),
          (_ctx.$slots.info || _ctx.info)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: ['info', _ctx.infoClasses]
              }, [
                _renderSlot(_ctx.$slots, "info", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.info), 1)
                ], {}, true)
              ], 2))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (_ctx.$slots.append)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: [_ctx.appendClasses]
          }, [
            _createVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "append", {}, undefined, true)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.hasError)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.errors[0]), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.fadedOut)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: "faded-out-overlay",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('click')))
        }))
      : _createCommentVNode("", true)
  ], 2))
})